export default __webpack_public_path__ + "static/media/right-blue-arrow.0efca31e.svg";